export default {
	list: 'TransactionLog',
	columns: {
		Id: {
			class: 'id',
			dataName: 'Id',
			type: 'number',
			title: 'Id',
			width: 100,
			hidden: true,
			readOnly: false
		},
		BusinessEvent: {
			class: "choice",
			dataName: 'BusinessEvent',
			type: 'string',
			title: 'Business Event',
			width: 100,
			hidden: true,
			readOnly: false
		},
		ProgramId: {
			class: "lookup",
			dataName: 'ProgramId',
			type: 'number',
			title: 'Program Id',
			width: 100,
			hidden: false,
			readOnly: false
		},
		ProgramTitle: {
			class: "lookup",
			dataName: 'Program/Title',
			type: 'string',
			title: 'Program Name',
			width: 100,
			hidden: false,
			readOnly: true
		},
		PartnerId: {
			class: "lookup",
			dataName: 'PartnerId',
			type: 'number',
			title: 'Partner Id',
			width: 100,
			hidden: false,
			readOnly: false
		},
		PartnerFullName: {
			class: "lookup",
			dataName: 'Partner/FullName',
			type: 'string',
			title: 'Partner FullName',
			width: 100,
			hidden: false,
			readOnly: true
		},
		PartnerID: {
			class: "lookup",
			dataName: 'Partner/PartnerID',
			type: 'number',
			title: 'Partner ID',
			width: 100,
			hidden: true,
			readOnly: true
		},
		PartnerTaxStatus: {
			class: "lookup",
			dataName: 'Partner/TaxStatus',
			type: 'string',
			title: 'Partner Tax Status',
			width: 100,
			hidden: true,
			readOnly: true
		},
		UnitClass: {
			class: 'choice',
			dataName: 'UnitClass',
			type: 'string',
			title: 'Unit Class',
			width: 100,
			hidden: false,
			readOnly: false
		},
		UnitType: {
			class: 'choice',
			dataName: 'UnitType',
			type: 'string',
			title: 'Unit Type',
			width: 100,
			hidden: false,
			readOnly: false
		},
		UnitPool: {
			class: 'choice',
			dataName: 'UnitPool',
			type: 'string',
			title: 'UnitPool',
			width: 100,
			hidden: false,
			readOnly: false
		},
		Unit: {
			class: 'value',
			dataName: 'Unit',
			type: 'number',
			title: 'Unit',
			width: 100,
			hidden: false,
			template: '#=kendo.format("{0:n2}", Unit )#',
			readOnly: false
		},
		TransactionDate: {
			class: 'value',
			dataName: 'TransactionDate',
			type: 'date',
			title: 'Date',
			width: 100,
			hidden: false,
			readOnly: false
		},
		TransactionId: {
			class: 'value',
			dataName: 'TransactionId',
			type: 'string',
			title: 'TransactionId',
			width: 100,
			hidden: true,
			readOnly: false
		},
		VestingType: {
			class: 'choice',
			dataName: 'VestingType',
			type: 'string',
			title: 'Vesting Type',
			width: 150,
			hidden: false
		}
	}
}